import { Highlight, themes } from "prism-react-renderer";
import { AbsoluteFill, useCurrentFrame } from "remotion";
import { BRAND, FONTS } from "./theme";

/**
 * Frames-to-revealed-lines ramp. Pure function (unit-tested): from frame 0,
 * reveal `totalLines` linearly across `revealFrames`, clamped to [0, total].
 */
export function revealedLineCount(
  frame: number,
  totalLines: number,
  revealFrames: number,
): number {
  if (frame <= 0) return 0;
  const n = Math.floor((frame / revealFrames) * totalLines);
  return Math.max(0, Math.min(totalLines, n));
}

/**
 * Animated source-code display: prism-highlighted code on a glass card tilted
 * in 3D-perspective, with line-by-line reveal and highlight-on-cue. Rendered as
 * a DOM sibling of <Stage> so the text stays crisp (no WebGL texture blur).
 */
export const CodePanel: React.FC<{
  code: string;
  language?: string;
  highlightLines?: number[];
  revealFrames?: number;
  title?: string;
  fontSize?: number;
}> = ({
  code,
  language = "tsx",
  highlightLines = [],
  revealFrames = 45,
  title,
  fontSize = 27,
}) => {
  const frame = useCurrentFrame();
  const lines = code.replace(/\n$/, "").split("\n");
  const shown = revealedLineCount(frame, lines.length, revealFrames);
  return (
    <AbsoluteFill style={{ alignItems: "center", justifyContent: "center" }}>
      <div
        style={{
          transform: "perspective(1600px) rotateY(-9deg) rotateX(3deg)",
          transformOrigin: "center",
          width: 1180,
          borderRadius: 18,
          overflow: "hidden",
          boxShadow: `0 30px 120px rgba(34,224,255,0.18)`,
          border: `1px solid rgba(139,92,246,0.5)`,
        }}
      >
        {title && (
          <div
            style={{
              fontFamily: FONTS.mono,
              fontSize: 22,
              color: BRAND.textDim,
              background: "#0B1730",
              padding: "12px 22px",
              borderBottom: `1px solid #1b2c52`,
            }}
          >
            {title}
          </div>
        )}
        <Highlight code={code} language={language} theme={themes.nightOwl}>
          {({ style, tokens, getLineProps, getTokenProps }) => (
            <pre
              style={{
                ...style,
                margin: 0,
                padding: "26px 30px",
                fontFamily: FONTS.mono,
                fontSize,
                lineHeight: 1.5,
                background: "#0A1226",
              }}
            >
              {tokens.map((line, i) => {
                const hl = highlightLines.includes(i + 1);
                return (
                  <div
                    key={i}
                    {...getLineProps({ line })}
                    style={{
                      opacity: i < shown ? 1 : 0,
                      background: hl ? "rgba(34,224,255,0.12)" : "transparent",
                      borderLeft: hl
                        ? `3px solid ${BRAND.cyan}`
                        : "3px solid transparent",
                      paddingLeft: 12,
                    }}
                  >
                    {line.map((token, key) => (
                      <span key={key} {...getTokenProps({ token })} />
                    ))}
                  </div>
                );
              })}
            </pre>
          )}
        </Highlight>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
